import template from "./monthly_report.html";
import controller from "./monthly_report.controller";
import "./monthly_report.scss";

let branchManagementMonthlyReportComponent = {
    restrict: "E",
    binding: {},
    template,
    controller
};

export default branchManagementMonthlyReportComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/monthly_report/monthly_report.component.js